import { jsx } from "react/jsx-runtime";
import SettingsCellIcon from "@mui/icons-material/SettingsCell";
import { validateTidalLicense } from "../../base/index.js";
function SettingsCell(props) {
  return /* @__PURE__ */ jsx(
    SettingsCellIcon,
    {
      "data-testid": "SettingsCell",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "SettingsCell",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
SettingsCell.tidalIconMeta = {
  categories: "devices,photos",
  name: "SettingsCell"
};
validateTidalLicense();
export {
  SettingsCell
};
//# sourceMappingURL=SettingsCell.js.map
